'use client';

import LinkComponent from '../product/_components/LinkComponent';
import { productPageHierarchy } from '../product/_components/productPageHierarchy';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <div className="no-scrollbar sticky top-[0px] z-[100] w-full overflow-x-scroll scroll-smooth bg-dark-background text-gray-5">
        <div className="max-w-section flex w-fit justify-end px-4 py-2 md:w-full">
          <ul className="text-body flex h-11 items-center gap-6">
            <li className="grid place-items-center">
              <LinkComponent href="/develocity">Overview</LinkComponent>
            </li>

            {Object.values(productPageHierarchy).map(pillar => (
              <li key={pillar.pillarPage.title} className="grid place-items-center">
                <LinkComponent href={pillar.pillarPage.href}>{pillar.pillarPage.title}</LinkComponent>
              </li>
            ))}

            <li className="grid place-items-center">
              <LinkComponent href="/develocity/solutions/security/">Security</LinkComponent>
            </li>
          </ul>
        </div>
      </div>

      {children}
    </>
  );
}
